import { RecordLibraryTransferStatus } from '../modules/documents-uploads';

export const ACTOR_APP = 'app';

export const DEFAULT_METADATA_VALUES_SEPARATOR = ';';

export const FINAL_RECORD_LIBRARY_TRANSFER_STATUSES: RecordLibraryTransferStatus[] =
  [RecordLibraryTransferStatus.FAILED, RecordLibraryTransferStatus.SUCCESSFULL];

export const SUCCESSFULL_RECORD_LIBRARY_TRANSFER_STATUSES: RecordLibraryTransferStatus[] =
  [RecordLibraryTransferStatus.SUCCESSFULL];

export const FAILED_RECORD_LIBRARY_TRANSFER_STATUSES: RecordLibraryTransferStatus[] =
  [RecordLibraryTransferStatus.FAILED];

export const WAITING_RECORD_LIBRARY_TRANSFER_STATUSES: RecordLibraryTransferStatus[] =
  [RecordLibraryTransferStatus.AWAITING_INSPECTIONS_COMPLETION];

export const ATTEMPTED_RECORD_LIBRARY_TRANSFER_STATUSES: RecordLibraryTransferStatus[] =
  [RecordLibraryTransferStatus.FAILED, RecordLibraryTransferStatus.SUCCESSFULL];
